module.exports = global["jQuery"] = require("-!/var/www/umem/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/jquery/dist/jquery.js
// module id = 1
// module chunks = 0